import CanShow from "./CanShow";
import DriversPage from "@/features/operations/verifications/drivers/pages/page";
import DonationsPage from "@/features/operations/verifications/donations/pages/page";
import VerifyPage from "@/features/operations/verifications/verify/pages/page";
import StatisticsPage from "@/features/operations/verifications/statistics/pages/page";
import ContactMessages from "@/features/operations/contactMessages/Index";

export const operationsRoutes = [
  {
    path: "/verifications-drivers",
    element: (
      <CanShow
        page={<DriversPage />}
        ifHas={["canDoProjectVerification", "verificationManager"]}
      />
    ),
  },
  {
    path: "/verifications-donations",
    element: (
      <CanShow
        page={<DonationsPage />}
        ifHas={["canDoProjectVerification", "verificationManager"]}
      />
    ),
  },
  {
    path: "/verifications-verify",
    element: (
      <CanShow
        page={<VerifyPage />}
        ifHas={["canDoProjectVerification", "verificationManager"]}
      />
    ),
  },
  {
    path: "/verifications-statistics",
    element: (
      <CanShow page={<StatisticsPage />} ifHas={["verificationManager"]} />
    ),
  },
  {
    path: "/contact-messages",
    element: (
      <CanShow
        page={<ContactMessages />}
        ifHas={["viewComplaintsAndSuggestions"]}
      />
    ),
  },
];
